import {
  Component,
  OnInit,
  HostListener,
  ChangeDetectorRef,
  AfterViewInit,
  Input,
  TemplateRef
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PasswordValidatorService } from '@shared/services/password-validator/password-validator.service';
import { EMAIL } from '@shared/constants/email.ts';
import { StepsService } from '@shared/services/steps/steps.service';
import { PersonalDetailsService } from '@shared/api/steps/personal-details/personal-details.service';
import { SIGNUP_HEADERS } from '@shared/constants/signup-headers.ts';
import { SessionService, ConvertKitService } from '@shared/services';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { PrivacyPolicyComponent } from '@shared/components/modals/privacy-policy/privacy-policy.component';
import { TermsOfUseComponent } from '@shared/components/modals/terms-of-use/terms-of-use.component';
import { PreOrderService } from '@modules/pre-order/api/pre-order/pre-order.service';
import { Router, ActivatedRoute } from '@angular/router';
import { UrlQueryStringService } from '@shared/services/url-query-string/url-query-string.service';
import { ViewportService } from '@shared/services/viewport/viewport.service';

@Component({
  selector: 'personal-details',
  templateUrl: './personal-details.component.html',
  styleUrls: ['./personal-details.component.scss']
})
export class PersonalDetailsComponent implements OnInit, AfterViewInit {
  closeBanner: boolean = false;
  personalDetails: any;
  personalDetailsForm: FormGroup;
  readTermsOfUseAndPrivacy: boolean;
  emailExist: boolean = false;
  isDesktop;
  isTablet;
  isMobile;
  preOrderDetails;
  modalRef: BsModalRef;
  modalConfig = {
    ignoreBackdropClick: true,
    class: 'modal-sm'
  };
  moduleName;
  isPreOrder;

  emailParams: string = '';
  @HostListener('window:resize', ['$event'])
  onResize() {
    setTimeout(() => {
      this._viewportService.checkViewSizes();
    }, 250);
  }

  @Input()
  set PreOrderDetails(details) {
    this.preOrderDetails = details;
  }

  constructor(
    private formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private _passwordValidatorService: PasswordValidatorService,
    private _stepsService: StepsService,
    private _stepPersonalDetailsService: PersonalDetailsService,
    private changeDetectorRef: ChangeDetectorRef,
    private _sessionServices: SessionService,
    private modalService: BsModalService,
    private router: Router,
    private _preOrderService: PreOrderService,
    private _urlQueryStringService: UrlQueryStringService,
    private _convertkit: ConvertKitService,
    private _viewportService: ViewportService
  ) {
    this._viewportService.updatingView.subscribe(() => {
      this.isDesktop = this._viewportService.isDesktop();
      this.isTablet = this._viewportService.isTablet();
      this.isMobile = this._viewportService.isMobile();
      if (this._stepsService.getCurrentStep() === 0) {
        this.changeDetectorRef.detectChanges();
      }
    });
  }

  ngOnInit() {
    if (
      this.activatedRoute.snapshot.queryParams &&
      this.activatedRoute.snapshot.queryParams.email
    ) {
      this.emailParams = this.activatedRoute.snapshot.queryParams.email;
    }
    this.moduleName = this._stepsService.getModuleName();
    if (!this.moduleName) {
      this.router.navigate(['/app/properties']);
    }
    this.isPreOrder = this._stepsService.isCurrentModulePreOrder(
      this.moduleName
    );
    this.personalDetailsForm = this.formBuilder.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      email: [
        this.emailParams,
        [Validators.required, Validators.pattern(EMAIL.EMAIL_REGEX)]
      ],
      password: [
        '',
        [Validators.required, this._passwordValidatorService.isValid]
      ],
      confirmPassword: ['', Validators.required],
      isAccreditedInvestor: '0'
    });
    this.readTermsOfUseAndPrivacy = false;
    this.emailExist = false;
  }

  ngAfterViewInit() {
    this._viewportService.checkViewSizes();
  }

  get controls() {
    return this.personalDetailsForm.controls;
  }

  submit() {
    if (this.personalDetailsForm.invalid) {
      return;
    }
    window.scrollTo(0, 0);
    this.setPersonalDetails(this.personalDetailsForm);
    this._stepsService.setHeaderTexts(SIGNUP_HEADERS.CONTACT_INFORMATION);
    this._stepsService.setDoneSteps([0]);
    this._stepsService.setTransitionDirection('RIGHT');
    this._stepsService.setCurrentStep(1);
  }

  setPersonalDetails(details) {
    const info = Object.assign({}, details.value);
    info.userName = info.email.trim();
    info.isEAC = this._urlQueryStringService.getEAC() === 1;
    info.isAccreditedInvestor = !!parseInt(info.isAccreditedInvestor, 10);
    this._stepPersonalDetailsService.setPersonalDetails(info).subscribe(res => {
      this._convertkit
        .createAccountForm({ email: info.email, first_name: info.firstName })
        .subscribe();
      this._stepsService.setSession('username', res.userName);
      const obj = {
        isLogin: false,
        username: res.userName
      };
      localStorage.setItem('currentUser', JSON.stringify(obj));
      this._sessionServices.setToken(res.token);
      this._preOrderService.setPreOrderStep(res.userName, 1).subscribe(() => {
        this._stepsService.setSession('step_id', 1);
      });
    });
  }

  checkEmailExist() {
    const email = { email: this.controls.email.value };
    if (!!email.email && this.controls.email.status === 'VALID') {
      this._stepPersonalDetailsService.checkEmailExist(email).subscribe(res => {
        this.emailExist = res.exists;
      });
    }
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template);
  }

  showPrivacyPolicyModal(e) {
    e.preventDefault();
    this.modalConfig.ignoreBackdropClick = false;
    this.modalConfig.class = 'modal-lg';
    this.modalRef = this.modalService.show(
      PrivacyPolicyComponent,
      this.modalConfig
    );
  }

  showTermsOfUseModal(e) {
    e.preventDefault();
    this.modalConfig.ignoreBackdropClick = false;
    this.modalConfig.class = 'modal-lg';
    this.modalRef = this.modalService.show(
      TermsOfUseComponent,
      this.modalConfig
    );
  }

  signIn() {
    this.router.navigate(['/login']);
    // this.router.navigate(['/login'], {
    //   queryParams: {
    //     returnUrl: this.router.url.toString()
    //   }
    // });
  }
}
